import { cardIcon, downloadLightIcon } from "assets/icons";
import { Select } from "components/form";
import React, { useEffect, useState } from "react";
import { GoClock } from "react-icons/go";
import "./BillsReport.scss";
import { Offcanvas } from "react-bootstrap";
import TransactionDetails from "./section/TransactionDetails";
import DownloadStatement from "./section/DownloadStatement";
import InfiniteScroll from "react-infinite-scroll-component";
import { transactionListApi } from "services/dashboard";
import { failMessage } from "utils/toastMessage";
import Placeholder from "components/placeholder/Placeholder";
import { useSelector } from "react-redux";
import { dateMonthFormat, indFormatPrice } from "utils/commonFun";
import BillDue from "pages/homePage/payment/BillDue";
import HistoryShimmer from "shimmer/transactionHistory/HistoryShimmer";
import { useLocation, useParams } from "react-router-dom";
import { exportBill } from "./exportBill";
import Spinners from "loader/Spinners";

const BillsReport = () => {
  const [transactionModal, setTransactionModal] = useState(false);
  const [selectedData, setSelectedData] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const { selectedSite } = useSelector((state) => (state?.selectedSite))
  const [transactionList, setTransactionList] = useState([])
  const [loading, setLoading] = useState(false)
  const [loader, setLoader] = useState(false)
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  // const { orderId } = useParams()
  // console.log('transactionList', transactionList)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("order_id");
  // console.log('main Bill Report', orderId)
  // --------------transaction-details---------------------
  const transactionDetailsModal = (data) => {
    setTransactionModal(true)
    setSelectedData(data)
  }

  //--------transaction-listing--------------
  const fetchTransactionList = async (page = 1, isRefresh = false) => {
    if (selectedSite?._id) {
      try {
        setLoading(true)
        const res = await transactionListApi({
          plantId: selectedSite?._id,
          limit: 12,
          page,
        })
        if (res?.status === 200) {
          const data = res?.data?.data
          if (isRefresh) {
            setTransactionList(data || []);
          } else {
            setTransactionList((prev) => [...prev, ...(data || [])]);
          }
          setHasMore(data.length === 12);
        } else {
          failMessage(res)
        }
      } catch (e) {
        console.log('error', e?.message)
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchTransactionList(1, true);
  }, [selectedSite?._id]);

  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    setPage(nextPage);
    fetchTransactionList(nextPage);
  };
  return (
    <>
      <div className="bills_report">
        <div className="container">
          {/* -------------bill------------------ */}
          <BillDue {...{ orderId }} />

          <div className="transaction">
            <div className="has_child">
              <h4>Transaction History</h4>

              {transactionList.length > 0 &&
                // <div className="button_section">
                //   <button type="button" disabled={transactionList.length === 0} className="input" onClick={() => setDownloadModal(true)}>
                //     Export Excel <img src={downloadLightIcon} />
                //   </button>
                // </div>
                <div className="button_section">
                  <button disabled={loader} onClick={() => exportBill(selectedSite, setLoader)} type="button" className="input" >
                    {loader ? <>Export Term Overview <Spinners /></> :
                      <>
                        Export Term Overview <img src={downloadLightIcon} />
                      </>
                    }
                  </button>
                </div>
              }
            </div>

            <div className="list">
              <InfiniteScroll
                dataLength={transactionList.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={selectedSite?._id ? <HistoryShimmer count={2} /> : ""}
              >
                {(!loading && transactionList.length === 0) ? (
                  <Placeholder title={"No data Found"} />
                ) : (transactionList.length > 0 && transactionList.map((data, ind) => (
                  <div key={ind} className="item" onClick={() => transactionDetailsModal(data)}>
                    <div className="content-left">
                      <img src={cardIcon} alt="" />
                      <p>
                        <b>{data?.month} {data?.year}</b>
                        {data?.billingStatus !== 'Payment_Pending' && <span>Paid on : {dateMonthFormat(data?.transactionDate)}</span>}
                      </p>
                    </div>
                    <p>
                      {data?.billingStatus == 'Paid' && <span className="tag paid"> {data?.billingStatus}</span>}
                      {data?.billingStatus == 'Payment_Pending' && <span className="tag bill">Pending</span>}

                      <strong>{indFormatPrice(data?.amount)}</strong>
                    </p>
                  </div>
                )))
                }
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>

      <Offcanvas
        placement="end"
        backdrop="static"
        show={transactionModal}
        onHide={() => setTransactionModal(false)}
      >
        <TransactionDetails modalClose={() => setTransactionModal(false)} data={selectedData} selectedSite={selectedSite} />
      </Offcanvas>

      {/* download Statement */}


      <Offcanvas
        placement="end"
        backdrop="static"
        show={downloadModal}
        onHide={() => setDownloadModal(false)}
      >
        <DownloadStatement modalClose={() => setDownloadModal(false)} />
      </Offcanvas>
    </>
  );
};

export default BillsReport;
